import ExperiecneListContainer from '../conatiner/createStarChart.expereinceList.container/ExperiecneListContainer'
import CreateStarChartActionContainer from '../conatiner/createStarChart.action.container/CreateStarChartActionContainer'
import { CreateStarChartContentContainer, CreateStarChartExperienceList } from '../presentation/createStarChart/CreateStarChartHeaderPresentation.style'
import CreateStarChartHeaderContainer from '../conatiner/createStarChart.header/CreateStarChartHeaderContainer'
import React, { useEffect, useState } from 'react'
import Header from '../../../components/header/Header'
import { useAppSelector } from '../../../app/hooks'
import { type Category } from '../../category/types/types'
import { selectedProject } from '../../home/appSlice/appslice'
import { type SubCategory } from '../../subcategory/types/types'
import { type EntityId, type EntityState } from '@reduxjs/toolkit'
import { type ExperienceCard } from '../types/types'
import { selectAdmin } from '../../auth/authSlice/authSlice'
import { useDeleteExpriencePreRequisiteMutation, useLazyGetAllExperiencesQuery } from '../../experience/api/experienceCardApiSlice'

const CreateStarChartPage = () => {

    const project = useAppSelector(selectedProject)
    const projectApp = useAppSelector(selectedProject)
    const admin = useAppSelector(selectAdmin)
    const [starChartAssignArg, setstarChartAssignArg] = useState<boolean>(false)
  
    const [ deleteExperPreReq ] = useDeleteExpriencePreRequisiteMutation()
    const [category, setCategory] = useState<Partial<Category> | null>(null)
    const [subCategory, setSubCategory] = useState<Partial<SubCategory> | null>(
      null
    )
    const [page, setPage] = useState<number>(1)
    const [limit, setLimit] = useState<number>(25)
    const [sort, setSort] = useState<string>('-createdAt')
    const [term, setTerm] = useState<string>('null')
    const [listStatus, setListStatus] = useState<'organizations' | 'experiences'>('experiences')
    const [starChartName, setStarChartName] = useState<string>('')
    const [experienceCards, setExperienceCards] =
      useState<EntityState<ExperienceCard> | null>(null)
  
    const [getAllExperiences, { isSuccess }] =
      useLazyGetAllExperiencesQuery();


      const onstarChartAssignArg = () => {
        setstarChartAssignArg(!starChartAssignArg)
      }

  
    useEffect(() => {
      (async () => {
        try {
          const expList = await getAllExperiences({
            project: project!._id!,
            category: category?._id,
            subCategory: subCategory?._id,
            expPublish: listStatus === 'experiences',
            expSave: listStatus === 'organizations',
            page,
            limit,
            sort,
            term,
          }).unwrap();
          setExperienceCards(expList);
        } catch (error) {
          console.error(error)
        }
      })();
    }, [category, subCategory, page, limit, sort, term, listStatus , starChartAssignArg]);
  
    useEffect(() => {
      if (admin) {
        const projectPermession = admin.projectAccess?.find(
          (item) => String(item.project) === String(projectApp?._id)
        )
  
        if (projectPermession) {
          if (projectPermession?.accessType === 'Full') {
            // setShowAddStudentButton(projectPermession.users!);
          }
        }
  
        if (admin.categoryAccess?.length === 1) {
          if (admin.categoryAccess[0].accessType === 'Full') {
            setCategory({ _id: admin.categoryAccess[0].category as EntityId })
          } else {
            setCategory({ _id: admin.categoryAccess[0].category as EntityId })
            setSubCategory({
              _id: admin.subCategoryAccess![0].subcategory as EntityId
            })
          }
        }
      }
    }, [admin])
  
    useEffect(() => {

      if (term !== 'null' && page > 1) {

        setPage(1)
      } else {

        setPage(page)
      }
    }, [term])
  

    const onTrem = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.value !== '') {
        setTerm(e.target.value)
      } else {
        setTerm('null')
      }
    }
  
    const onSort = (fieldName: string) => {

      if (sort === 'null') {
        setSort(`-${fieldName}`)
      }
      if (sort.startsWith('-')) {

        setSort(fieldName)
      }
      if (!sort.startsWith('-')) {

        setSort(`-${fieldName}`)
      }
    }
  
    const onPage = (pageNumber: number) => {
      setPage(pageNumber)
    }
  
    const onLimit = (limitNumber: number) => {
      setLimit(limitNumber)
    }
  
      const onDelete = (id: EntityId) => {
        if (confirm('Are you sure to remove this Experience?')) {
          try {
            deleteExperPreReq(id)
          } catch (error) {
            console.error(error)
          }
        }
  
        
      }

  const onOrganizations = () => {
    setListStatus('organizations')
  }
  const onExperiences = () => {
    setListStatus('experiences')
  }



  return <>      
        <Header title="Star Chart" />
        <CreateStarChartHeaderContainer starChartName={starChartName} setStarChartName={setStarChartName }/>

        <CreateStarChartContentContainer>

          <CreateStarChartActionContainer
              onTerm={onTrem}
              listStatus={listStatus}
              onExperiences={onExperiences}
              onOrganizations={onOrganizations}
              term={term}
              lastPosition={0}
              onstarChartAssignArg={onstarChartAssignArg} 
              starChartAssignArg={starChartAssignArg}              
          />
          <CreateStarChartExperienceList>
            {isSuccess && experienceCards && (
                <ExperiecneListContainer
                  list={experienceCards}
                  onSort={onSort}
                  sort={sort}
                  page={page}
                  limit={limit}
                  onPage={onPage}
                  onLimit={onLimit}
                  onDelete={onDelete}
                  
                  
                />
              )}
          </CreateStarChartExperienceList>
         
              
        </CreateStarChartContentContainer>

  </>
}

export default CreateStarChartPage
